import { CHUNK_RELOAD_MESSAGE, chunkReloader } from '@/lib/chunkReload';

/**
 * Story `fe-be-monteur-s5b-installeerbaar` (EPIC-021, S021.5b) §1.1 — "Laden…" zolang een lazy
 * scherm laadt; dezelfde laadstaat als `FitterShellRoute` vóór deze story. `fullScreen` voor
 * een schil (Chrome, de monteur-schil), anders vult hij het inhoudsvlak binnen de schil.
 */
export function RouteLoading({ fullScreen }: { fullScreen: boolean }) {
    return (
        <div
            data-testid="route-loading"
            className={`flex ${fullScreen ? 'h-screen' : 'min-h-[40vh]'} items-center justify-center text-sm text-muted-foreground`}
        >
            Laden…
        </div>
    );
}

/** §1.2 / AC 5 — de melding na een tweede mislukte poging: geen lus, wel een knop. */
export function ChunkReloadNotice() {
    return (
        <div role="alert" data-testid="chunk-reload-notice" className="flex min-h-[40vh] flex-col items-center justify-center gap-3 p-6 text-center">
            <p className="text-sm font-medium text-foreground">{CHUNK_RELOAD_MESSAGE}</p>
            <button
                type="button"
                onClick={() => chunkReloader().reloadByUser()}
                className="min-h-[44px] rounded-lg bg-[color:var(--brand,#132679)] px-4 text-sm font-semibold text-white"
            >
                Vernieuwen
            </button>
        </div>
    );
}
